/* eslint-disable */

export var EmailPropertyType;
(function (EmailPropertyType) {
  EmailPropertyType.APPARTAMENTO = 'appartamento';
  EmailPropertyType.PROGETTO = 'progetto';
  EmailPropertyType.STANZA = 'stanza';
  EmailPropertyType.GARAGE = 'garage';
  EmailPropertyType.UFFICIO = 'ufficio';
  EmailPropertyType.EDIFICIO = 'edificio';
  EmailPropertyType.TERRENO = 'terreno';
  EmailPropertyType.CAPANNONE = 'capannone';
  EmailPropertyType.VILLA = 'villa';
  EmailPropertyType.VILLETTA = 'villetta';
  EmailPropertyType.CASA = 'casa';
  EmailPropertyType.IMMOBILE = 'immobile';
  EmailPropertyType.ATTIVITA = 'attività';
}(EmailPropertyType || (EmailPropertyType = {})));
export var EmailContext;
(function (EmailContext) {
  EmailContext[EmailContext.DEFAULT = 0] = 'DEFAULT';
  EmailContext[EmailContext.TOUR = 1] = 'TOUR';
  EmailContext[EmailContext.NO_MEDIA = 2] = 'NO_MEDIA';
  EmailContext[EmailContext.ATTIVITA = 3] = 'ATTIVITA';
}(EmailContext || (EmailContext = {})));
